















import Vue from 'vue';
import NeonButton from '@/components/NeonButton.vue';
import Snake from '@/components/Snake.vue';

export default Vue.extend({
  name: 'DepartmentsPanel',
  components: {
    NeonButton,
    Snake,
  },
  methods: {
    onAboutUsClick() {
      this.$router.push('/om-oss');
    },
    onMediaClick() {
      this.$router.push('/media');
    },
    onTechnologyClick() {
      this.$router.push('/teknologi');
    },
  },
});
